import { FunctionComponent, useState } from 'react';
import {
    Card,
    CardContent,
    InputAdornment,
    SvgIcon,
    FilledInput,
    InputLabel,
    FormControl,
    FormControlLabel,
    Checkbox,
    Box,
} from '@mui/material';
import MagnifyingGlassIcon from '@heroicons/react/24/solid/MagnifyingGlassIcon';

type WebshopFilterProps = {
    onChange: (nextValue: string) => void;
    onShowInactiveChange: (showInactive: boolean) => void;
};

export const WebshopFilter: FunctionComponent<WebshopFilterProps> = ({
    onChange,
    onShowInactiveChange,
}) => {
    const [textValue, setTextValue] = useState('');
    const [showInactive, setShowInactive] = useState(false);

    const handleTextChange = (event) => {
        const { value } = event.target;

        setTextValue(value);
        onChange(value);
    };

    const handleShowInactiveChange = (event) => {
        const { checked } = event.target;

        setShowInactive(checked);
        onShowInactiveChange(checked);
    };

    return (
        <Card
            sx={{
                width: '100%',
            }}
        >
            <CardContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <FormControl variant='filled' fullWidth>
                        <InputLabel>Webshops durchsuchen</InputLabel>
                        <FilledInput
                            value={textValue}
                            onChange={handleTextChange}
                            startAdornment={
                                <InputAdornment position='start'>
                                    <SvgIcon>
                                        <MagnifyingGlassIcon />
                                    </SvgIcon>
                                </InputAdornment>
                            }
                            fullWidth
                        />
                    </FormControl>

                    <Box>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showInactive}
                                    onChange={handleShowInactiveChange}
                                />
                            }
                            label='Inaktive anzeigen'
                        />
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};
